// extracted by mini-css-extract-plugin
module.exports = {"compare":"Compare_compare__3d2VP"};